export default {
  flagReview: {
    form: {
      buttonText: 'Submit',
    },
  },
  card: {
    report: 'Report',
    verifiedPurchase: 'Verified Purchase',
    voteCount: {
      one: '{{count}} person found this helpful',
      other: '{{count}} people found this helpful',
    },
  },
  voteButton: {
    helpful: 'Helpful',
  },
};
